import {
  REVIEWER_CONTEXT_FLAG_KEYS,
  type ReviewerContextFlagKey,
  type ReviewerContextFlags,
  type ReviewerRow,
} from '@nightshift/ui-types';

import { canWriteSettings } from './privilege.ts';

export const REVIEWER_FLAG_COPY: Record<
  ReviewerContextFlagKey,
  { label: string; help: string; locked: boolean }
> = {
  ticketContext: {
    label: 'Ticket context',
    help: 'Always on. The ticket brief, comments, and acceptance criteria.',
    locked: true,
  },
  mrDiff: {
    label: 'MR diff',
    help: 'The merge request diff against the target branch. On by default.',
    locked: false,
  },
  fullCheckout: {
    label: 'Full checkout',
    help: 'Check out the repository at the MR head SHA so the reviewer can diff and read surrounding code. On by default; the MR diff is still supplied alongside.',
    locked: false,
  },
  namedCiArtifacts: {
    label: 'Named CI artifacts',
    help: 'Named artifacts from the verification contract. Off by default.',
    locked: false,
  },
};

export function toggleOptionalFlag(
  flags: ReviewerContextFlags,
  key: Exclude<ReviewerContextFlagKey, 'ticketContext'>,
): ReviewerContextFlags {
  return { ...flags, [key]: !flags[key] };
}

export function reviewerFlagKeys(): ReviewerContextFlagKey[] {
  return [...REVIEWER_CONTEXT_FLAG_KEYS];
}

export function canWriteReviewers(user: { role: string } | null): boolean {
  return canWriteSettings(user);
}

/**
 * Where a reviewer's machine, harness, model and thinking come from. Stated on the panel so
 * nobody looks here for a model field: reviewers are identities, routes live in the cascade.
 */
export const REVIEWER_ROUTES_NOTE =
  'Which machine, harness, model and thinking run this reviewer comes from the ticket override, then the project\u2019s Reviewer routes under Project \u2192 Execution, then the default agent routes under Nightshift \u2192 Models.';

export function newReviewerDraft(): {
  name: string;
  prompt: string;
  contextFlags: ReviewerRow['contextFlags'];
  vendorExclusion: boolean;
  enabled: boolean;
} {
  return {
    name: '',
    prompt: '',
    contextFlags: {
      ticketContext: true,
      mrDiff: true,
      fullCheckout: true,
      namedCiArtifacts: false,
    },
    vendorExclusion: false,
    enabled: true,
  };
}
